import { render, staticRenderFns } from "./techrequirements.vue?vue&type=template&id=0c684a56&"
import script from "./techrequirements.vue?vue&type=script&lang=js&"
export * from "./techrequirements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports